const mediaItems = [
  {
    title: '网红翻车名场面合集',
    desc: '那些年翻过的车，一个比一个离谱',
    img: 'https://readdy.ai/api/search-image?query=Social%20media%20influencer%20dramatic%20fail%20moment%20captured%20on%20phone%20screen%2C%20dark%20atmospheric%20lighting%2C%20neon%20pink%20accents%2C%20cinematic%20thriller%20aesthetic%2C%20night%20vibe%2C%20glowing%20smartphone%20in%20dark%20room%2C%20suspenseful%20mood%2C%20editorial%20photography&width=640&height=360&seq=media-card-01&orientation=landscape',
  },
  {
    title: '娱乐圈不雅内幕深度起底',
    desc: '台前光鲜亮丽，幕后触目惊心',
    img: 'https://readdy.ai/api/search-image?query=Dark%20backstage%20of%20an%20empty%20theater%20with%20spotlight%20casting%20dramatic%20shadows%2C%20mysterious%20atmosphere%2C%20amber%20and%20pink%20mood%20lighting%2C%20entertainment%20industry%20secrets%20visual%20metaphor%2C%20cinematic%20noir%20style%2C%20film%20grain%20texture%2C%20editorial%20photography&width=640&height=360&seq=media-card-02&orientation=landscape',
  },
  {
    title: '酒店猛料48小时追踪',
    desc: '深夜走廊的脚步声究竟是谁',
    img: 'https://readdy.ai/api/search-image?query=Empty%20luxury%20hotel%20corridor%20at%20night%20with%20dim%20warm%20lighting%2C%20long%20perspective%20hallway%2C%20mysterious%20atmosphere%2C%20pink%20and%20amber%20ambient%20glow%2C%20suspenseful%20cinematic%20mood%2C%20editorial%20photography%20style%2C%20high%20contrast%20shadows&width=640&height=360&seq=media-card-03&orientation=landscape',
  },
  {
    title: '反差视频：台上台下两副面孔',
    desc: '镜头前温柔可人，镜头后暴怒失控',
    img: 'https://readdy.ai/api/search-image?query=Split%20screen%20visual%20contrast%20between%20glamorous%20stage%20performance%20and%20dark%20backstage%20reality%2C%20dramatic%20lighting%20contrast%2C%20pink%20and%20dark%20color%20palette%2C%20celebrity%20duality%20concept%2C%20editorial%20photography%2C%20artistic%20composition%2C%20high%20drama%20aesthetic&width=640&height=360&seq=media-card-04&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-foreground-950">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-black text-white mb-10 text-center">
          反差视频精选区
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item, idx) => (
            <div key={idx} className="group relative rounded-2xl overflow-hidden aspect-video bg-foreground-800 cursor-pointer">
              <img
                src={item.img}
                alt={item.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-14 h-14 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center group-hover:bg-primary-500/80 transition-all duration-300">
                  <i className="ri-play-fill text-white text-2xl ml-0.5"></i>
                </div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <h3 className="text-white text-sm font-bold leading-snug mb-1">{item.title}</h3>
                <p className="text-white/60 text-xs opacity-0 group-hover:opacity-100 transition-opacity duration-300">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}